import {
  useCurrentWorkspace,
  useProductFilter,
  useSetProductFilter,
} from '@gripp/shared-logic';
import {
  Colors,
  countFilters,
  FilterHeaders,
  ProductsSearchInput,
  SlideAction,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { AddButton } from '../../shared/components/addButton/addButton';
import { ModalButton } from '../../shared/components/modalButton';
import { CreateProductForm } from './createProductForm';

export const ProductsFilters = () => {
  const navigate = useNavigate();
  const { currentViewMode, onSlideChange } = useSlideLayout();
  const currentWorkspace = useCurrentWorkspace();

  const { data: productFilter } = useProductFilter();
  const { mutateAsync: setProductFilter } = useSetProductFilter();
  const filterCount = countFilters(productFilter);

  const onFilterNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    navigate('/products/filters');
  };

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        currentSearchKeyword={productFilter?.keyword}
        searchComponent={<ProductsSearchInput />}
        onFilterPress={onFilterNavigate}
        onSearchClose={() =>
          setProductFilter({ ...productFilter, keyword: '' })
        }
        filterCount={filterCount}
        Routes={{}}
      />

      {currentWorkspace && (
        <ModalButton
          label=""
          customButton={(toggleVisibility) => (
            <AddButton onPress={() => toggleVisibility(true)} />
          )}
          modalComponent={({ onComplete }) => (
            <CreateProductForm
              onComplete={onComplete}
              workspaceId={currentWorkspace.id}
            />
          )}
          containerStyle={styles.modalContainer}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
  },
  modalContainer: {
    flex: 1,
    alignSelf: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 560,
    maxHeight: 193,
    borderRadius: 12,
    backgroundColor: Colors.primaryGrayBackground,
  },
});
